import type { LucideIcon } from 'lucide-react';
import type React from 'react';
import { StatCard, type StatTone } from './StatCard.js';
import { cn } from '../../utils/cn.js';

type Severity = 'danger' | 'warning' | 'accent' | 'success' | 'purple';

export interface StatStripCell {
  label: string;
  value: React.ReactNode;
  sub?: React.ReactNode;
  /** Colours the cell's icon tile; leave unset for a neutral number. */
  severity?: Severity;
  icon?: LucideIcon;
}

interface StatStripProps {
  cells: StatStripCell[];
  className?: string;
}

/**
 * The summary numbers above a list or dashboard (NextAdmin overview-stats grid): two per row on phones, all in one
 * row from `lg`. Show a summary only when it answers a question the list itself does not (entity-management §1.2).
 */
export function StatStrip({ cells, className }: StatStripProps) {
  return (
    <div
      className={cn('mb-4 grid grid-cols-2 gap-4 lg:grid-cols-[repeat(var(--stat-cols),minmax(0,1fr))]', className)}
      style={{ '--stat-cols': cells.length } as React.CSSProperties}
    >
      {cells.map((cell) => {
        const Icon = cell.icon;
        const tone: StatTone = cell.severity ?? 'neutral';
        return (
          <StatCard
            key={cell.label}
            label={cell.label}
            value={cell.value}
            sub={cell.sub}
            tone={tone}
            icon={Icon ? <Icon /> : undefined}
            className="p-4"
          />
        );
      })}
    </div>
  );
}
